export const codeType = 'code';
